<app-page>
  <ng-template #headerTpl>
    <app-header></app-header>
  </ng-template>

  <ng-template #mainTpl>
    <div class="cities">
      <ng-container *ngFor="let city of cities$ | async">
        <div>
          <a [routerLink]="['/cities', city.slug]" [queryParams]="searchParams | async" queryParamsHandling="merge">Hostels in {{city.name}}, {{city.country.name === 'United States' ? city.state.name : city.country.name}}</a>
        </div>
      </ng-container>
    </div>
  </ng-template>
</app-page>
